import { Button, Grid, IconButton, Stack } from "@mui/material";

/**
 * Icon button is only contain icon as indication
 *
 * ! When using this icon button type please add relevant style along with icon element
 * @param icon : icon element which need to be displayed
 *
 */
export const CustomIconButton = ({ icon, onClick, height, width }) => {
  return (
    <Button
      variant={"lightBlue"}
      sx={{
        borderRadius: "18px",
        width: width ? width : "60px",
        height: height ? height : "24px",
      }}
      onClick={onClick}
    >
      {icon}
    </Button>
  );
};

/**
 * Icon button type 2 is display icon next to button label
 *
 * ! When passing a Icon add the relevant css style along with Icon
 * @param icon : icon on the button
 * @param width : width of the button
 * @param height : height of the button
 * @param borderRadius : border radius of the button
 * @param fontSize : font size of the button
 * @param fontWeight : font weight of the button
 * @param title :  title of the button
 *
 */
export const CustomIconButton2 = ({
  icon,
  width,
  height,
  variant,
  borderRadius,
  fontSize,
  fontWeight,
  title,
  onClick,
  spacing,
  color,
}) => {
  return (
    <Button
      disableTouchRipple
      variant={variant ? variant : "lightBlue"}
      sx={{
        borderRadius: borderRadius,
        width: width,
        height: height,
        fontSize: fontSize,
        fontWeight: fontWeight,
      }}
      onClick={onClick}
    >
      <Stack direction={"row"} alignItems={"center"}>
        <Grid>{icon}</Grid>
        <Grid ml={spacing} color={color}>
          {title}
        </Grid>
      </Stack>
    </Button>
  );
};

/**
 * Icon button is only contain icon as indication
 *
 * ! When using this icon button type please add relevant style along with icon element
 * @param icon : icon element which need to be displayed
 *
 */
export const CustomIconButton3 = ({ icon, onClick }) => {
  return <IconButton onClick={onClick}>{icon}</IconButton>;
};
